module.exports = __webpack_public_path__ + "img/doremy sweet_sc1.90be82ad.png";